import React, { useEffect } from 'react';
import { Link } from "react-router-dom";

import { Alert, Box, Grid, List, ListItemButton, ListItemText, Paper, Snackbar, Stack, Typography } from "@mui/material";


import Map from "../../../components/Map/Map";
import AddProjectStepper from "../components/AddProjectStepper";
import DatePickerProject from "../components/DatePickerProject";
import EditorInput from "../components/EditorInput";
import { CssBox, CssButton, CssTextField } from "../components/StyledComponent";
import DropzoneFile from '../components/DropzoneFile';

import { searchAddress } from '../../../services/DataGov/Address';
import moment from 'moment';
import { createProjetApi } from '../../../services/Api/Projet';
import { createLogementApi } from '../../../services/Api/Logement';

import { useDispatch, useSelector } from 'react-redux';
import { resetState } from '../../../store/features/Project';

const styles = {
  titleInput1: {
    color: "#46bda7",
    fontWeight: "lighter",
  },
  subtitleInput1: {
    fontWeight: "bolder",
    color: "#002f4f",
  },
  cssLink: {
    textDecoration: "none",
  },
  typoMenuLeft1: {
    color: "#002f4f",
  },
};

export default function AddInfoPage() {
  const [lonLat, setLonLat] = React.useState([])
  const [loadAddresses, setLoadAddresses] = React.useState([])
  const [address, setAddress] = React.useState('')
  const [preamble, setPreamble] = React.useState('')
  const [impact, setImpact] = React.useState('')
  const [description, setDescription] = React.useState('')
  const [contexte, setContexte] = React.useState('')
  const [startDate, setStartDate] = React.useState(moment())
  const [endDate, setEndDate] = React.useState(moment())
  const [amount, setAmount] = React.useState(0)
  const [lgtCloneData, setLgtCloneData] = React.useState(null)

  const [openSuccess, setOpenSucess] = React.useState(false)
  const [openError, setOpenError] = React.useState(false)

  const titleInStore = useSelector(state => state.project.title)
  const categoriesInStore = useSelector(state => state.project.categories)

  const dispatch = useDispatch();

  const handleCloseSuccess = () => {
    setOpenSucess(false)
  }
  const handleCloseError = () => {
    setOpenError(false)
  }

  const handleSearchInputAddress = async (text) => {
    setAddress(text)
    await setTimeout(() => {}, 300)
    const addressResults = await (await searchAddress(text)).json()
    setTimeout(() => {
      setLoadAddresses(addressResults.features)
    }, 3000);
  }

  const handleSelectAddress = (a) => {
    const lgtData = {
      adresse: a.properties.label, 
      lng: a.geometry.coordinates[0], 
      lat: a.geometry.coordinates[1], 
      code_postal: a.properties.postcode, 
      ville: a.properties.city,
      code_commune: a.properties.citycode,
      code_departement: (a.properties.postcode).slice(0, 2)
    }
    setLonLat(a.geometry.coordinates)
    setAddress(a.properties.label)
    setLoadAddresses([])
    setLgtCloneData(lgtData)
  }

  useEffect(() => {
    console.log("TITLE OF PROJECT", titleInStore)
  }, [address, preamble, impact, description, startDate, endDate, amount, contexte, titleInStore])

  const handleSaveButton = async () => {
    const data = {
      title: titleInStore,
      address: address,
      preamble: preamble,
      impact: impact,
      description: description,
      context: contexte,
      startDate: startDate.format("YYYY-MM-DD"),
      endDate: endDate.format("YYYY-MM-DD"),
      amount: parseFloat(amount),
      categories: categoriesInStore
    };
    try {
      const createProjet = await createProjetApi(data);
      const response = await createProjet.json()
      if(response.status === "success"){
        setOpenSucess(true)
        dispatch(resetState());
        if(address.length !== 0) {
          await createLogementApi(lgtCloneData)
        }
      } else {
        setOpenError(true)
      }
    } catch (error) {
      
    }
  }

  return (
    <>
      <Grid container>
        <Snackbar open={openSuccess} autoHideDuration={6000} onClose={handleCloseSuccess}>
          <Alert onClose={handleCloseSuccess} severity="success" sx={{ width: '100%' }}>
            Projet cree avec succes
          </Alert>
        </Snackbar>
        <Snackbar open={openError} autoHideDuration={6000} onClose={handleCloseError}>
          <Alert onClose={handleCloseError} severity="error" sx={{ width: '100%' }}>
            Erreur lors de la creation de projet
          </Alert>
        </Snackbar>
        <Grid
          item
          paddingTop={4}
          paddingLeft={2}
          paddingRight={2}
          xs={4}
          md={3}
          lg={2}
        >
          <Link to="/dashboard" style={styles.cssLink}>
            <CssBox>
              <Typography variant="subtitle2" style={styles.subtitleInput1}>
                Mes projets
              </Typography>
              <Typography variant="body2" style={styles.typoMenuLeft1}>
                Liste de mes projets
              </Typography>
            </CssBox>
          </Link>
        </Grid>
        <Grid 
          item 
          container 
          direction="column" 
          xs={8} md={9} lg={10}
          sx={{
            backgroundColor: '#F7F8FF',
            borderRadius: "40px 0 0 0",
          }}
        >
          <Grid
            container
            direction="row"
            justifyContent="center"
            marginTop={5}
            marginBottom={10}
          >
            <Box width="20%">
              <AddProjectStepper step={2} />
            </Box>
          </Grid>

          <Grid
            container
            direction="column"
            paddingLeft={5}
            marginTop={5}
            marginBottom={1}
          >
            <Typography variant="h4" style={styles.titleInput1}>
              Detail du projet
            </Typography>
            <Typography variant="body1" style={styles.subtitleInput1}>
              Ajouter les details du projet
            </Typography>
            <Box marginTop={5}>
              <CssTextField
                helperText=" "
                label="Saisir une adresse"
                size="small"
                sx={{
                  width: "25%"
                }}
                value={address}
                onChange={async (e) => await handleSearchInputAddress(e.target.value)}
              />
              {
                loadAddresses.length !== 0 ? (
                  <Paper sx={{ width: "50%", padding: 0, position: "relative"}} elevation={0}>
                    <List sx={{position: "absolute", top: "-20px", zIndex: 999999999, bgcolor: "white"}}>
                      {loadAddresses && loadAddresses.map(a => (
                        <ListItemButton key={a.properties.score} onClick={() => handleSelectAddress(a)}>
                          <ListItemText>{a.properties.label}</ListItemText>
                        </ListItemButton>
                      ))}
                    </List>
                  </Paper>
                ):(<></>)
              }
            </Box>
          </Grid>

          <Grid item sx={{ padding: 5 }}>
            <Paper sx={{ height: "calc(100vh - 300px)", width: "calc(50% + 20%)" }} elevation={0}>
              {
                lonLat.length === 0 ? (
                  <><Map lonLat={[4.91781, 46.1827780]} /></>
                ) : ( <><Map lonLat={lonLat} /></>)
              }
              
            </Paper>
          </Grid>


          <Grid item  sx={{ padding: 5 }}>
            <Paper sx={{width: "calc(50% + 20%)", backgroundColor: "transparent"}} elevation={0}>
              <Typography variant="subtitle1" color="secondary" sx={{ fontWeight: "bolder", marginBottom: 3 }}>
                PREAMBULE
              </Typography>
              <EditorInput setValue={setPreamble}  />
            </Paper>
          </Grid>


          <Grid item  sx={{ padding: 5 }}>
            <Paper sx={{width: "calc(50% + 20%)", backgroundColor: "transparent"}} elevation={0}>
              <Typography variant="subtitle1" color="secondary" sx={{ fontWeight: "bolder", marginBottom: 3 }}>
                CONTEXTE DU PROJET
              </Typography>
              <EditorInput setValue={setContexte} />
            </Paper>
          </Grid>


          <Grid item  sx={{ padding: 5 }}>
            <Paper sx={{width: "calc(50% + 20%)", backgroundColor: "transparent"}} elevation={0}>
              <Typography variant="subtitle1" color="secondary" sx={{ fontWeight: "bolder", marginBottom: 3 }}>
                DESCRIPTIF DU PROJET
              </Typography>
              <EditorInput setValue={setDescription} />
            </Paper>
          </Grid>

          <Grid item  sx={{ padding: 5 }}>
            <Paper sx={{width: "calc(50% + 20%)", backgroundColor: "transparent"}} elevation={0}>
              <Typography variant="subtitle1" color="secondary" sx={{ fontWeight: "bolder", marginBottom: 3 }}>
                IMPACT DU PROJET
              </Typography>
              <EditorInput setValue={setImpact} />
            </Paper>
          </Grid>

          <Grid item  sx={{ padding: 5 }}>
            <Paper sx={{backgroundColor: "transparent"}} elevation={0}>
              <Typography variant="subtitle1" color="secondary" sx={{ fontWeight: "bolder", marginBottom: 3 }}>
                DATE PREVISIONNELLE DU PROJET
              </Typography>
              <Stack direction="row" spacing={5}>
                <DatePickerProject label="Date de debut" setDate={setStartDate} />
                <DatePickerProject label="Date de fin" setDate={setEndDate} initDate={startDate} initDefaultDate={setEndDate} />
              </Stack>
            </Paper>
          </Grid>

          <Grid item  sx={{ padding: 5 }}>
            <Paper sx={{width: "calc(50% + 20%)", backgroundColor: "transparent"}} elevation={0}>
              <Typography variant="subtitle1" color="secondary" sx={{ fontWeight: "bolder", marginBottom: 3 }}>
                DOCUMENT LIER AU PROJET
              </Typography>
              <DropzoneFile />
            </Paper>
          </Grid>

          <Grid item  sx={{ padding: 5 }}>
            <Paper sx={{width: "calc(50% + 20%)", backgroundColor: "transparent"}} elevation={0}>
              <Typography variant="subtitle1" color="secondary" sx={{ fontWeight: "bolder", marginBottom: 3 }}>
                ESTIMATION DU PRIX
              </Typography>
              <CssTextField
                helperText=" "
                label="Saisir un prix"
                size="small"
                onChange={(e) => setAmount(e.target.value)}
              />
            </Paper>
          </Grid>

          <Grid container direction="row" justifyContent="center" sx={{ marginBottom: 5 }}>
            <CssButton variant="contained" onClick={async () => await handleSaveButton()}>Enregistrer</CssButton>
          </Grid>

        </Grid>
      </Grid>
    </>
  );
}
